export default "__VITE_ASSET__ByJ4WfrD__"